import { render, staticRenderFns } from "./BnplPurchaseCartTile.vue?vue&type=template&id=653b3c92&"
import script from "./BnplPurchaseCartTile.vue?vue&type=script&lang=js&"
export * from "./BnplPurchaseCartTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports